export default __webpack_public_path__ + "static/media/vizio-v-series.580d902c.png";